module.exports = __webpack_public_path__ + "static/media/galerija_2013 (10).c5238f4d.jpg";